module.exports = __webpack_public_path__ + "img/logo.ab064047.svg";